import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";

interface IconTextProps {
    icon: React.ReactNode;
    text: string;
}

const IconText: React.FC<IconTextProps> = ({ icon, text }) => {
    return (
        <Stack direction={"row"} spacing={1}>
            {icon}
            <Typography variant={"body2"}>{text}</Typography>
        </Stack>
    );
};

export default IconText;
